
import Vue from 'vue'

import QuantityInput from '@/components/QuantityInput.vue'
import { SERVER_ERRORS } from '@/pages/product/const'
import { Estimate } from '@/model/estimate'

export default Vue.extend({
  components: {
    QuantityInput
  },
  data(): {
    showModalPriceTable: boolean
    updatingQuantity: boolean
  } {
    return {
      showModalPriceTable: false,
      updatingQuantity: false
    }
  },
  computed: {
    estimate(): Estimate {
      return this.$store.getters.estimate
    },
    trial() {
      return this.$route.query.trial
    },
    quantities() {
      return this.$store.getters.quantities
    },
    product() {
      return this.$store.getters.product
    },
    showQuantityInput(){
      return !this.estimate.trial && this.quantities && this.quantities.quantity
    },
    printCapacity() {
      return this.estimate.print_capacity_per_day?.remaining_quantity
    },
    trialErrorMessage() {
      return this.$store.state.serverError && this.$store.state.serverError.code  === SERVER_ERRORS.NO_TRIAL_SUPPORT
        ? this.$store.state.serverError.message
        : ''
    },
    colorPatternName(): string {
      const displayName = this.estimate.selected_color_pattern?.color_pattern.display_name
      const splitDisplayName = displayName.split('(')
      return splitDisplayName?.[0].trim()
    }
  },
  watch: {
    trial() {
      this.$refs.quantityInput?.validateQuantity(this.quantities.quantity)
    }
  },
  mounted() {
    if (this.printCapacity !== undefined && this.quantities.quantity > this.printCapacity) {
      this.$store.commit('setValidQuantity', false)
    }
  },
  methods: {
    onChangeQuantity({ quantity, hasErrors }) {
      if (hasErrors) {
        this.$store.commit('setValidQuantity', false)
        return
      }
      this.$store.commit('setValidQuantity', true)
      this.$store.commit('setQuantity', quantity)
      this.$emit('refreshProductInfo', { disabledLoading: true })
      this.updatingQuantity = false
      this.$store.commit('setUpdatingQuantityInput', false)
    },
    onUpdatingQuantity() {
      this.$store.commit('setUpdatingQuantityInput', true)
    }
  }
})
